import React from 'react'
import styled from 'styled-components'
import { mixins, colors } from '../css-variables'
import classNames from '../../utils/classNames'

const PageSectionHeader = ({
    className,
    heading,
    pageTitle,
    fromBlocks,
    ...classes
}) => {
    const classList = classNames(className, {
        bgimage: classes?.bgimage,
        social: classes?.withSocial,
        hangingAlt: classes?.headingAlt,
        compact: classes?.headingCompact,
        leftAlign: classes?.leftAlign,
        groupPage: classes?.groupPage,
        excerpt: classes?.excerpt,
    })

    return (
        <div className={classList}>
            {fromBlocks && (
                <div dangerouslySetInnerHTML={{ __html: heading }} />
            )}
            {!fromBlocks && pageTitle && <h1>{heading}</h1>}
            {!fromBlocks &&
                (!pageTitle || typeof pageTitle === 'undefined') && (
                    <h2>{heading}</h2>
                )}
        </div>
    )
}

const StyledPageSectionHeader = styled(PageSectionHeader)`
    ${mixins.sectionHeader}
    &.bgimage,
    &.headingAlt {
        width: 100%;
        h2 {
            color: ${colors.titleWhite};
        }
        &:after {
            background-color: ${colors.bgWhite};
        }
    }
`

export default StyledPageSectionHeader
